import React from "react";
import { Grid, Box } from "@mui/material";
import TutorialCard from "./tutorial-card";

const TutorialGrid = ({ tutorials, isMediumScreen, onClick }) => {
  return (
    <Box
      //  sx={{ height: "100vh" }}
      mb={10}
    >
      <Grid
        container
        pb={isMediumScreen ? 24 : 14}
        spacing={3}
        justifyContent="start"
      >
        {tutorials.map((tutorial) => (
          <Grid item key={tutorial.id} xs={12} sm={6} lg={6} xl={4}>
            <TutorialCard
              {...tutorial}
              isMediumScreen={isMediumScreen}
              onClick={onClick}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TutorialGrid;
